(() => {
  function mount(root) {
    if (root.dataset.cartGroupsReady) return;
    root.dataset.cartGroupsReady = 'true';
    const form = root.querySelector('form');
    if (!form) return;
    const groups = new Map();
    root.querySelectorAll('[data-cart-configuration]').forEach(row => {
      const id = row.dataset.cartConfiguration;
      if (!id) return;
      if (!groups.has(id)) groups.set(id, []);
      groups.get(id).push(row);
    });
    for (const rows of groups.values()) {
      const base = rows.find(row => row.dataset.cartRole === 'base');
      const input = base?.querySelector('[name="updates[]"]');
      if (!input) continue;
      const addons = rows.filter(row => row.dataset.cartRole === 'material');
      const labels = new Map();
      for (const row of addons) {
        // Keep named inputs in the cart form so Shopify receives all quantities.
        const actions = row.querySelector('.bp-cart__actions');
        if (actions) actions.hidden = true;
        const label = document.createElement('p');
        label.className = 'bp-cart__variant';
        row.querySelector('.cart-item__body')?.append(label);
        labels.set(row, label);
      }
      const sync = () => {
        const quantity = Math.max(0, Math.floor(Number(input.value) || 0));
        for (const row of addons) {
          const field = row.querySelector('[name="updates[]"]');
          if (field) field.value = String(quantity);
          labels.get(row).textContent = `Quantity: ${quantity} · follows configured kit`;
        }
      };
      input.addEventListener('input', sync);
      input.addEventListener('change', sync);
      form.addEventListener('submit', sync);
      base.querySelector('.bp-cart__remove')?.addEventListener('click', event => {
        event.preventDefault();
        input.value = '0';
        sync();
        form.requestSubmit(form.querySelector('[name="update"]'));
      });
      sync();
    }
  }
  const boot = (scope = document) => {
    const roots = [...scope.querySelectorAll('[data-bp-cart-groups]')];
    if (scope.matches?.('[data-bp-cart-groups]')) roots.unshift(scope);
    roots.forEach(mount);
  };
  boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
